class FeaturedCollectionNew extends HTMLElement {
  constructor() {
    super();
    this.mainSlider = document.querySelector(".sliderNew");
    this.innerSlider = document.querySelectorAll(".innerslider");

    this.init(this.mainSlider, this.innerSlider);
  }


  init(firstSlide, innerSlider) {
    var flkty = new Flickity(firstSlide, {
      contain: true,
      pageDots: false,
      imagesLoaded: false,
      initialIndex: 0,
      cellAlignment: "left",
      draggable: true,
      resize: false,
      autoPlay: false,
      on: {
        settle: function () {

        },
        ready: function () {
          setTimeout(() => { this.resize(); }, 3000);

        }
      }
    });

    for (var i = 0, len = innerSlider.length; i < len; i++) {
      var innerSliderSingle = innerSlider[i];
      var innerflickity = new Flickity(innerSliderSingle, {
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: true,
        draggable: false,
        groupCells: 1,
        accessibility: true,
        resize: false,
        autoPlay: false,
        imagesLoaded: true,
        on: {
          settle: function () {
            this.resize();
          }
        }

      });

    }


  }


}


customElements.define('featured-collection-new', FeaturedCollectionNew);
